import { pathOr } from 'ramda';

import { INewbuildingHouseDecorationSchema } from 'shared/repositories/offer-card/entities/newbuilding_decoration/NewbuildingHouseDecorationSchema';
import { IState } from 'shared/store';

export const getDecorationsInHouse = (state: IState): INewbuildingHouseDecorationSchema[] => {
  return pathOr([], ['offerData', 'housingDecorations'], state);
};
